import { render } from "./PopupMenu.vue?vue&type=template&id=767edf77&ts=true"
import script from "./PopupMenu.vue?vue&type=script&lang=ts"
export * from "./PopupMenu.vue?vue&type=script&lang=ts"

import "./PopupMenu.vue?vue&type=style&index=0&id=767edf77&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__